import { Component, JSX } from 'solid-js';
import { clsx } from 'clsx';
import { translations } from './i18n';

declare global {
    interface Window {
        lang: "ro" | "en";
    }
}

const InviteCnt: Component<{children?: JSX.Element, class?: string, childrenBetweenVerseAndTitle?: JSX.Element}> = (props) => {
    const t = translations[window.lang ?? "ro"];

    return (
        <div class={clsx("invite-cnt", props.class)}>
            <img src="/static/left-bottom-flowers.jpeg" class="absolute bottom-0 left-0 w-[160px] z-0"/>
            <img src="/static/right-bottom-flowers.jpeg" class="absolute bottom-0 right-0 w-[160px] z-0"/>
            <div class="main">
<div class="flex flex-col items-center justify-center relative text-center invite-text-transition">
                    <div class="mb-[22px] mt-4">
                        <div class="text-sm italic">„{t.quote}"</div>
                        <div class="text-xs mt-2">{t.quoteAuthor}</div>
                    </div>
                    { props.childrenBetweenVerseAndTitle }
                    <div class="alecs-and-oana">Alecs <span class="name-heart">♥</span> Oana</div>
                </div>
                <div class="relative mb-16 invite-text-transition">{ props.children }</div>
            </div>
        </div>
    );
}

export default InviteCnt;